import React from "react";
import "./AboutMe.css";

export default function AboutMe() {
  return (
    <div id="abouto" className="about-who">
      <div>
        <h1 className="hello"> About Me</h1>
      </div>
      <div className="brand">
        <p className="start-about">
          Welcome to my portfolio page! I am a
          quick-learner and communicative full-stack developer with a background
          in customer service. A dedicated and responsible person, with the
          drive to learn as much as possible. I am creative when it comes to
          problem solving and finding a solution that works for everyone. Most
          of my projects are based on hobbies. I have a quite a number of
          hobbies, a few of them are fishing, anime, poker, video games,
          billiards, editing videos, and chess to be honest the list goes on and
          on. I guess that is just the curiosity in me, once I see something
          that seems fun or interesting, I will give it my all to learn it.
        </p>
      </div>
    </div>
  );
}
